import React, { VFC } from 'react'
import styled from 'styled-components'

import Container from '@Components/CMS/Container'
import { TrustPilotWidget } from '@Components/TrustPilotWidget'

const TrustPilotRoot = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 20px;
  background-color: #f5f5f5;
  padding: 50px 0;
`

const StyledContainer = styled(Container)`
  margin-bottom: 0px;
`

interface TrustPilotProps {
  id?: string
}

const TrustPilot: VFC<TrustPilotProps> = ({ id }) => (
  <TrustPilotRoot id={id}>
    <StyledContainer width="medium">
      <TrustPilotWidget />
    </StyledContainer>
  </TrustPilotRoot>
)

export default TrustPilot
